import axios from 'axios';
import api from './api';

const API_BASE_URL = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000').trim().replace(/\/$/, '');

// Team side
export const bulletinAPI = {
  posts: (params) => api.get('/api/bulletin/posts', { params }),
  createPost: (data) => api.post('/api/bulletin/posts', data),
  updatePost: (id, data) => api.patch(`/api/bulletin/posts/${id}`, data),
  removePost: (id) => api.delete(`/api/bulletin/posts/${id}`),

  settings: () => api.get('/api/bulletin/settings'),
  updateSettings: (data) => api.patch('/api/bulletin/settings', data),

  subscribers: () => api.get('/api/bulletin/subscribers'),
  addSubscriber: (data) => api.post('/api/bulletin/subscribers', data),
  bulkSubscribers: (data) => api.post('/api/bulletin/subscribers/bulk', data),
  removeSubscriber: (id) => api.delete(`/api/bulletin/subscribers/${id}`),

  issues: () => api.get('/api/bulletin/newsletters'),
  createIssue: (data) => api.post('/api/bulletin/newsletters', data),
  updateIssue: (id, data) => api.patch(`/api/bulletin/newsletters/${id}`, data),
  removeIssue: (id) => api.delete(`/api/bulletin/newsletters/${id}`),
  duplicateIssue: (id) => api.post(`/api/bulletin/newsletters/${id}/duplicate`),
  previewIssue: (id) => api.get(`/api/bulletin/newsletters/${id}/preview`, { responseType: 'text' }),
  testIssue: (id) => api.post(`/api/bulletin/newsletters/${id}/test`),
  sendIssue: (id) => api.post(`/api/bulletin/newsletters/${id}/send`),
};

export const signupsAPI = {
  list: () => api.get('/api/signups'),
  create: (data) => api.post('/api/signups', data),
  get: (id) => api.get(`/api/signups/${id}`),
  update: (id, data) => api.patch(`/api/signups/${id}`, data),
  remove: (id) => api.delete(`/api/signups/${id}`),
  addEntry: (id, data) => api.post(`/api/signups/${id}/entries`, data),
  removeEntry: (id, entryId) => api.delete(`/api/signups/${id}/entries/${entryId}`),
  message: (id, data) => api.post(`/api/signups/${id}/message`, data),
  exportCsv: (id) => api.get(`/api/signups/${id}/export`, { responseType: 'blob' }),
};

// Public side (no login)
const pub = axios.create({ baseURL: API_BASE_URL });
export const boardPublicAPI = {
  board: (slug) => pub.get(`/api/board-public/${slug}`),
  subscribe: (slug, data) => pub.post(`/api/board-public/${slug}/subscribe`, data),
  event: (slug, id) => pub.get(`/api/signup-public/e/${slug}/${id}`),
  join: (slug, id, data) => pub.post(`/api/signup-public/e/${slug}/${id}/join`, data),
};

// datetime-local input <-> ISO (the browser's own time zone)
export const toLocalInput = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d)) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
export const fromLocalInput = (v) => (v ? new Date(v).toISOString() : null);

const browserTz = (() => { try { return Intl.DateTimeFormat().resolvedOptions().timeZone; } catch (e) { return undefined; } })();
export const fmtWhen = (iso, opts = {}) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d)) return '';
  return d.toLocaleString('en-US', { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: browserTz, ...opts });
};
export const fmtSpan = (start, end) => {
  if (!start) return '';
  if (!end) return fmtWhen(start);
  const s = new Date(start); const e = new Date(end);
  const sameDay = s.toDateString() === e.toDateString();
  return `${fmtWhen(start)} – ${sameDay ? e.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) : fmtWhen(end)}`;
};
